
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 119.98 119.98"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M720.52,936.1H640.65a20.06,20.06,0,0,0-20.06,20V1036a20.06,20.06,0,0,0,20.06,20h79.87a20,20,0,0,0,20.05-20V956.15A20,20,0,0,0,720.52,936.1Zm-1.76,91.84a6.32,6.32,0,0,1-6.33,6.33H648.74a6.32,6.32,0,0,1-6.32-6.33V964.25a6.32,6.32,0,0,1,6.32-6.32h63.69a6.32,6.32,0,0,1,6.33,6.32Z","transform":"translate(-620.59 -936.1)","fill":"#231f20"}}),_c('path',{attrs:{"d":"M667.85,1012.45a3.64,3.64,0,0,1-3.63-3.65V983.38a3.64,3.64,0,0,1,3.63-3.65h25.47a3.64,3.64,0,0,1,3.63,3.65v25.42a3.64,3.64,0,0,1-3.63,3.65Z","transform":"translate(-620.59 -936.1)","fill":"#231f20"}})])
          )
        }
      }
    